module.exports = __webpack_public_path__ + "static/media/paisagemudf-mu.258d2933.jpg";